import getAPIMap from "../api_map.js";
import axios from "axios";
import { whatsAppTopCampaigns } from "../reports_data.js";
import {
  customDateStartUTCTimeZone,
  customDateEndUTCTimeZone,
  customDateStartUTCTimeZoneZ,
  customDateEndUTCTimeZoneZ,
  getTimeZoneInHours,
  customDateStartWithoutTz,
  customDateEndWitoutTz,
  customDateFormatStartAndEnd,
} from "../utils/DateOrdinals.js";
import getIP from "../getIP.js";
const IP = getIP();
import dayjs from "dayjs";
import { productNames, tableDetails } from "constants_map.js";

const interfaceTypeMapping = {
  volumetricsPanel: "",
  smsVolumetricsPanel: "API",
  smppVolumetricsPanel: "SMPP",
  cmpgnMsgData: "WEB",
  ftpVolumetricsPanel: "FTP",
  emailVolumetricsPanel: "",
};

const waInterfaceMapping = {
  volumetricsPanel: "1",
  smsVolumetricsPanel: "1",
  smppVolumetricsPanel: "3",
  cmpgnMsgData: "0",
  ftpVolumetricsPanel: "2",
};

const getPerformancePie = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  let fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  let tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";

  var category = "";
  var channel = "";
  var direction = "";

  if (queryKey[5] === "All Channels") {
    channel = queryKey[4]
      ? queryKey[4] === "Voice"
        ? `&pr_tp=Voice`
        : queryKey[4] === "Virtual Receptionist"
        ? `&pr_tp=VR`
        : ""
      : "";
    direction = queryKey[4] && queryKey[4] === "WhatsApp" ? `&dir=0` : "";
  } else {
    category =
      queryKey[4] || queryKey[4] === 0
        ? queryKey[5] === "Virtual Receptionist" || queryKey[5] === "Voice"
          ? `&direction=${queryKey[4]}`
          : `&m_ctg=${queryKey[4]}`
        : "";
    channel = queryKey[5]
      ? queryKey[5] === "Voice"
        ? `&pr_tp=Voice`
        : queryKey[5] === "Virtual Receptionist"
        ? `&pr_tp=VR`
        : ""
      : "";
    direction = queryKey[5] && queryKey[5] === "WhatsApp" ? `&dir=0` : "";
    if (queryKey[5] && queryKey[5] === "WhatsApp") {
      fDate = queryKey[2]
        ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
        : "";
      tDate = queryKey[3]
        ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
        : "";
    }
  }

  const urlMap = {
    Voice: "getVoicePerformancePie",
    "Virtual Receptionist": "getVoicePerformancePie",
    SMS: "getPerformancePie",
    WhatsApp: "getWAVolumetricsPanel",
    Email: "getEmailPerformancePie",
  };

  // q5 contains specific channel get url of that channel
  // else (All Channel) get url from the q4
  var url = `${IP}${getAPIMap(
    urlMap[queryKey[5]] ? urlMap[queryKey[5]] : urlMap[queryKey[4]]
  )}${
    fDate && tDate ? `?${fDate}&${tDate}` : ``
  }${category}${channel}${direction}`;
  let response = await axios.get(url, config);
  return response;
};

const getInterfacePie = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  let fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  let tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  const channel = queryKey[5]
    ? queryKey[5] === "Voice"
      ? `&pr_tp=Voice`
      : queryKey[5] === "Virtual Receptionist"
      ? `&pr_tp=VR`
      : ""
    : "";

  const waOption = queryKey[5] === "WhatsApp" ? `&category=i_tp` : "";
  if (queryKey[5] && queryKey[5] === "WhatsApp") {
    fDate = queryKey[2]
      ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
      : "";
    tDate = queryKey[3]
      ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
      : "";
  }
  const urlMapping = {
    Voice: "getVoiceInterfacePie",
    "Virtual Receptionist": "getVoiceInterfacePie",
    WhatsApp: "getWAVolumetricsPanel",
    SMS: "getInterfacePie",
    Email: "getInterfacePieEmail",
  };
  var url = `${IP}${getAPIMap(urlMapping[queryKey[5]])}${
    fDate && tDate ? `?${fDate}&${tDate}` : ``
  }${channel}${waOption}`;
  let response = await axios.get(url, config);
  return response;
};

const getSummaryPanel = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  var url =
    IP +
    getAPIMap("getSummaryPanel") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;

  let response = await axios.get(url, config);
  return response;
};
export const getEmailVolPanelData = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  var url =
    IP +
    getAPIMap("getEmailVolPanelData") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;

  let response = await axios.get(url, config);
  return response;
};

const getWASummaryPanel = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2]
    ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
    : "";
  const tDate = queryKey[3]
    ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
    : "";

  // const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  // const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";

  var url =
    IP +
    getAPIMap("getWAVolumetricsPanel") +
    `${fDate && tDate ? `?${fDate}&${tDate}&dir=0` : ""}`;

  let response = await axios.get(url, config);
  return response;
};

const getAllEmailVolPanel = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  var url =
    IP +
    getAPIMap("getAllEmailVolPanel") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;

  let response = await axios.get(url, config);
  return response;
};

const getVolumetricsPanel = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  let fDate = queryKey[2]
    ? `fDate=${customDateFormatStartAndEnd(queryKey[2], "0")}`
    : "";
  let tDate = queryKey[3]
    ? `tDate=${customDateFormatStartAndEnd(queryKey[3], "1")}`
    : "";

  let iType = "";
  let channel = "";
  let category = "";
  let direction = "";

  if (queryKey[5] === "All Channels") {
    iType =
      queryKey[4] === "Voice" || queryKey[4] === "Virtual Receptionist"
        ? ""
        : interfaceTypeMapping[queryKey[0]] &&
          `&i_tp=${interfaceTypeMapping[queryKey[0]]}`;
    channel = queryKey[4]
      ? queryKey[4] === "Voice"
        ? `&pr_tp=Voice`
        : queryKey[4] === "Virtual Receptionist"
        ? `&pr_tp=VR`
        : ""
      : "";
  } else {
    // Not all channels
    iType =
      queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
        ? ""
        : interfaceTypeMapping[queryKey[0]] &&
          `&i_tp=${interfaceTypeMapping[queryKey[0]]}`;
    channel = queryKey[5]
      ? queryKey[5] === "Voice"
        ? `&pr_tp=Voice`
        : queryKey[5] === "Virtual Receptionist"
        ? `&pr_tp=VR`
        : ""
      : "";
    category = queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
  }

  if (
    queryKey[5] === "WhatsApp" ||
    (queryKey[5] === "All Channels" &&
      (queryKey[4] === "WhatsApp" ||
        queryKey[4] === "SMS" ||
        queryKey[4] === "Email"))
  ) {
    fDate = queryKey[2]
      ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
      : "";
    tDate = queryKey[3]
      ? `tDate=${customDateEndUTCTimeZoneZ(
          queryKey[3].includes("%")
            ? queryKey[3].split("%")[0] + "Z"
            : queryKey[3]
        )}`
      : "";

    if (queryKey[5] === "WhatsApp" && queryKey[0] === "smsVolumetricsPanel") {
      iType =
        waInterfaceMapping[queryKey[0]] &&
        `&i_tp=${waInterfaceMapping[queryKey[0]]}`;
    }

    direction = `&dir=0`;
  }

  const urlMap = {
    Voice: "getVoiceVolumetricsPanel",
    "Virtual Receptionist": "getVoiceVolumetricsPanel",
    SMS: "getVolumetricsPanel",
    WhatsApp: "getWAVolumetricsPanel",
    Email: "getVolumetricsPanelEmail",
  };

  var url = `${IP}${getAPIMap(
    urlMap[queryKey[5]]
      ? urlMap[queryKey[5]]
      : urlMap[queryKey[4]]
      ? urlMap[queryKey[4]]
      : urlMap[queryKey[6]]
      ? urlMap[queryKey[6]]
      : urlMap["SMS"]
  )}${
    fDate && tDate ? `?${fDate}&${tDate}` : ``
  }${category}${channel}${iType}${direction}`;
  let response = await axios.get(url, config);
  return response;
};
const getVoiceVolumetricsPanel = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";

  var url = `${IP}${getAPIMap("getVoiceVolumetricsPanel")}${
    fDate && tDate ? `?${fDate}&${tDate}` : ``
  }`;
  let response = await axios.get(url, config);
  return response;
};
export const getAcctOverview = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
    params: {
      // startDate: queryKey[2] ? queryKey[2].split("T")[0] : "",
      // endDate: queryKey[3] ? queryKey[3].split("T")[0] : "",
    },
  };

  const url = `${IP}${getAPIMap("getAcctOverview")}`;
  const response = await axios.get(url, config);
  return response;
};
export const getTrafficFlowAnalysis = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
    params: {
      fDate: queryKey[2] ? customDateStartUTCTimeZoneZ(queryKey[2]) : "",
      tDate: queryKey[3] ? customDateEndUTCTimeZoneZ(queryKey[3]) : "",
      dir: 0
    },
  };

  const url = `${IP}${getAPIMap("getTrafficFlowAnalysis")}`;
  const response = await axios.get(url, config);
  return response;
};
export const getTrafficAnalysis = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
    params: {
      fDate: queryKey[2] ? customDateStartUTCTimeZoneZ(queryKey[2]) : "",
      tDate: queryKey[3] ? customDateEndUTCTimeZoneZ(queryKey[3]) : "",
      dir: 0
    },
  };

  const url = `${IP}${getAPIMap("getTrafficAnalysis")}`;
  const response = await axios.get(url, config);
  return response;
};
export const getMonthlyRevenue = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
    params: {
      fDate: queryKey[2] ? customDateStartUTCTimeZoneZ(queryKey[2]) : "",
      tDate: queryKey[3] ? customDateEndUTCTimeZoneZ(queryKey[3]) : "",
    },
  };

  const url = `${IP}${getAPIMap("getMonthlyRevenue")}`;
  const response = await axios.get(url, config);
  return response;
};

const getApiCallsPanel = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  let fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  let tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  const category =
    queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";

  const channel = queryKey[5]
    ? queryKey[5] === "Voice"
      ? `&pr_tp=Voice&i_tp=API`
      : queryKey[5] === "Virtual Receptionist"
      ? `&pr_tp=VR`
      : ""
    : "";

  if (queryKey[5] && queryKey[5] === "WhatsApp") {
    fDate = queryKey[2]
      ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
      : "";
    tDate = queryKey[3]
      ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
      : "";
  }

  var url = `${IP}${getAPIMap(
    queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
      ? "getVoiceVolumetricsPanel"
      : queryKey[5] === "WhatsApp"
      ? "getWAVolumetricsPanel"
      : "getVolumetricsPanel"
  )}${fDate && tDate ? `?${fDate}&${tDate}` : ``}${category}${channel}`;
  let response = await axios.get(url, config);
  return response;
};

const getStatusTrendGraph = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  let fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  let tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";

  if (queryKey[5] && queryKey[5] === "WhatsApp") {
    fDate = queryKey[2]
      ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
      : "";
    tDate = queryKey[3]
      ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
      : "";
  }

  const category =
    queryKey[4] || queryKey[4] === 0
      ? queryKey[5] === "Virtual Receptionist"
        ? `&direction=${queryKey[4]}`
        : `&m_ctg=${queryKey[4]}`
      : "";
  const channel = queryKey[5]
    ? queryKey[5] === "Voice"
      ? `&pr_tp=Voice`
      : queryKey[5] === "Virtual Receptionist"
      ? `&pr_tp=VR`
      : ""
    : "";

  const apiMap = {
    Voice: "getVoiceStatusTrendGraph",
    "Virtual Receptionist": "getVoiceStatusTrendGraph",
    Email: "getEmailStatusTrendGraph",
    // WhatsApp: "getWhatsappStatusTrendGraph",
    WhatsApp: "getWaStatTrendGraph",
    DEFAULT: "getStatusTrendGraph",
  };
  const _url = getAPIMap(apiMap[queryKey[5]] || apiMap.DEFAULT);

  let url = `${IP}${_url}${
    fDate && tDate ? `?${fDate}&${tDate}` : ``
  }${category}${channel}`;

  // Whatsapp status trend api must need the below query param
  if (queryKey[5] === "WhatsApp") {
    let timeZone = getTimeZoneInHours();
    url += `&dir=0&timeRange=dayOfYear&timeZone=${timeZone}`;
  }

  const response = await axios.get(url, config);
  return response;
};

const getNumbersPanel = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  const capabilities =
    queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
      ? `&capabilities=voice`
      : "";
  const category =
    queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
  var url =
    IP +
    getAPIMap("getNumbersPanel") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${category}${capabilities}`;

  let response = await axios.get(url, config);
  return response;
};

const getNumberPanel = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2]
    ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
    : "";
  const tDate = queryKey[3]
    ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
    : "";
  const capabilities =
    queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
      ? `&capabilities=voice`
      : "";
  const category =
    queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
  var url =
    IP +
    getAPIMap("getNumberPanel") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${category}${capabilities}`;

  let response = await axios.get(url, config);
  return response;
};

const getSenderPie = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2]
    ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
    : "";
  const tDate = queryKey[3]
    ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
    : "";
  const category =
    queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
  var url =
    IP +
    getAPIMap("getSenderPie") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${category}`;

  let response = await axios.get(url, config);
  return response;
};

const getRevenueTrendEmail = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  const type =
    queryKey[0] === "getRevenuePieEmail"
      ? `&type=pie`
      : queryKey[0] === "getEmailRevenueTrend"
      ? "&type=trend"
      : "";
  var url =
    IP +
    getAPIMap("getRevenueTrendEmail") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${type}`;

  let response = await axios.get(url, config);
  return response;
};

const getSummaryRevenue = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2]
    ? `fDate=${customDateFormatStartAndEnd(queryKey[2], "0")}`
    : "";
  const tDate = queryKey[3]
    ? `tDate=${customDateFormatStartAndEnd(queryKey[3], "1")}`
    : "";
  const category =
    queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
  const type =
    queryKey[0] === "revenuePie"
      ? `&type=pie`
      : queryKey[0] === "usageTrend"
      ? "&type=trend"
      : "";
  var url =
    IP +
    getAPIMap("getSummaryRevenue") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${category}${type}`;

  let response = await axios.get(url, config);
  return response;
};

const getEmailMetrics = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const startDate = queryKey[2] ? `startDate=${queryKey[2]}` : "";
  const endDate = queryKey[3] ? `endDate=${queryKey[3]}` : "";
  const category =
    queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
  const type =
    queryKey[0] === "revenuePie"
      ? `&type=pie`
      : queryKey[0] === "usageTrend"
      ? "&type=trend"
      : "";
  var url =
    IP +
    getAPIMap("getEmailMetrics") +
    `${
      startDate && endDate ? `?${startDate}&${endDate}` : ""
    }${category}${type}`;
  let response = await axios.get(url, config);
  return response;
};

const getSummaryRevenueForVoice = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  // const category =
  //   queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
  var url =
    IP +
    getAPIMap("getSummaryRevenueForVoice") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;

  let response = await axios.get(url, config);

  return response;
};
const getCampaignRevenueForVoice = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  const category =
    queryKey[4] === "Voice"
      ? `&pr_tp=Voice`
      : queryKey[4] === "Virtual Receptionist"
      ? `&pr_tp=VR`
      : "";
  var url =
    IP +
    getAPIMap("getCampaignRevenueForVoice") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${category}`;

  let response = await axios.get(url, config);

  return response;
};
const getCampaignRevenue = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  const channel =
    queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
      ? `&channel=${queryKey[4]}`
      : "";
  var url =
    IP +
    getAPIMap("getCampaignRevenue") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;

  let response = await axios.get(url, config);
  return response;
};
export const getSummarySmsRevenueData = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  var url =
    IP +
    getAPIMap("getSummarySmsRevenueData") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;

  const response = await axios.get(url, config);
  return response;
};

const getAllEmailCampaignRevenue = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  const channel =
    queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
      ? `&channel=${queryKey[4]}`
      : "";
  var url =
    IP +
    getAPIMap("getAllEmailCampaignRevenue") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;

  let response = await axios.get(url, config);
  return response;
};

const getTopPackages = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  let fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  let tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  const channel =
    queryKey[5] && queryKey[5] !== "All Channels" && queryKey[5] !== "All"
      ? `&channel=${queryKey[5]}`
      : queryKey[4]
      ? `&channel=${queryKey[4]}`
      : "";

  var url = "";

  // if (queryKey[5] && (queryKey[5] === "WhatsApp" || queryKey[5] === "SMS")) {
  //   fDate = queryKey[2]
  //     ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
  //     : "";
  //   tDate = queryKey[3]
  //     ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3].split("%")[0] + "Z")}`
  //     : "";
  // }

  const urlMapping = {
    Voice: "getTopPackagesForVoice",
    WhatsApp: "getTopPackagesForWA",
    SMS: "getTopPackages",
    Email: "getTopPackagesForEmail",
  };

  url =
    IP +
    getAPIMap(
      urlMapping[queryKey[5]]
        ? urlMapping[queryKey[5]]
        : urlMapping[queryKey[4]]
    ) +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;

  // if (queryKey[4] === "Voice") {
  //   url =
  //     IP +
  //     getAPIMap("getTopPackagesForVoice") +
  //     `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;
  // } else {
  //   url =
  //     IP +
  //     getAPIMap("getTopPackages") +
  //     `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;
  // }
  let response = await axios.get(url, config);
  return response;
};

const getTopPackagesForVoice = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  const channel =
    queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
      ? `&channel=${queryKey[4]}`
      : "";
  var url =
    IP +
    getAPIMap("getTopPackagesForVoice") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;

  let response = await axios.get(url, config);
  return response;
};

const getTopPackagesForEmail = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  const channel =
    queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
      ? `&channel=${queryKey[4]}`
      : "";
  var url =
    IP +
    getAPIMap("getTopPackagesForEmail") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;

  let response = await axios.get(url, config);
  return response;
};

const getTopEnterprises = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  let fDate = queryKey[2]
    ? `fDate=${customDateFormatStartAndEnd(queryKey[2], "0")}`
    : "";
  let tDate = queryKey[3]
    ? `tDate=${customDateFormatStartAndEnd(queryKey[3], "1")}`
    : "";
  let channel =
    queryKey[5] && queryKey[5] !== "All Channels" && queryKey[5] !== "All"
      ? `&channel=${queryKey[5]}`
      : queryKey[4]
      ? `&channel=${queryKey[4]}`
      : "";
  let url = "";

  if (queryKey[5] && queryKey[5] === "WhatsApp") {
    fDate = queryKey[2]
      ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
      : "";
    tDate = queryKey[3]
      ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3].split("%")[0])}`
      : "";
  }

  const urlMapping = {
    Voice: "getTopEnterprisesForVoice",
    WhatsApp: "getTopEnterprisesForWA",
    SMS: "getTopEnterprises",
    Email: "getTopEnterprisesForEmail",
  };

  url =
    IP +
    getAPIMap(
      urlMapping[queryKey[5]]
        ? urlMapping[queryKey[5]]
        : urlMapping[queryKey[4]]
    ) +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;

  let response = await axios.get(url, config);
  return response;
};

const getTopEnterprisesforVoice = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  const channel =
    queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
      ? `&channel=${queryKey[4]}`
      : "";
  var url =
    IP +
    getAPIMap("getTopEnterprisesForVoice") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;

  let response = await axios.get(url, config);
  return response;
};
const getTopEnterprisesForEmail = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  const channel =
    queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
      ? `&channel=${queryKey[4]}`
      : "";
  var url =
    IP +
    getAPIMap("getTopEnterprisesForEmail") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;

  let response = await axios.get(url, config);
  return response;
};

const getNumberInventoryStatusPanel = async () => {
  let data = {
    revenue: "0",
    totalNumbers: "0",
    otc: "0",
    mrc: "0",
    totalInventory: "0",
    totalPurchased: "0",
  };
  return data;
};
const getNumberConfigurationPanel = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";

  var url =
    IP +
    getAPIMap("getNumberConfigurationPanel") +
    `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;

  let response = await axios.get(url, config);
  return response;
};
const getCampaignsPanel = async () => {
  let data = {
    revenue: "0",
    totalCamp: "0",
    scheduled: "0",
    completed: "0",
    inProgress: "0",
    paused: "0",
    failed: "0",
  };
  return data;
};

const getSmsCampaignPanel = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const fDate = queryKey[2]
    ? `stdt=${dayjs(queryKey[2]).format("YYYY-MM-DD")} ${dayjs().format(
        "HH:mm:ss"
      )}`
    : "";
  const tDate = queryKey[3]
    ? `enddt=${dayjs(queryKey[3])
        .subtract(1, "day")
        .format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
    : "";

  var url =
    IP +
    getAPIMap("getSmsCampaignPanel") +
    `?pgsize=1&pgindex=1${
      fDate && tDate ? `&${fDate}&${tDate}&duration=CUSTOM&channels=sms` : ""
    }`;

  let response = await axios.get(url, config);
  return response;
};

const getCampaignCallsPanel = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  const category =
    queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";

  const channel = queryKey[5]
    ? queryKey[5] === "Voice"
      ? `&pr_tp=Voice&i_tp=WEB`
      : queryKey[5] === "Virtual Receptionist"
      ? `&pr_tp=VR&i_tp=WEB`
      : ""
    : "";

  var url = `${IP}${getAPIMap(
    queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
      ? "getVoiceVolumetricsPanel"
      : "getVolumetricsPanel"
  )}${fDate && tDate ? `?${fDate}&${tDate}` : ``}${category}${channel}`;
  let response = await axios.get(url, config);
  return response;
};
const getAccountCount = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2] ? `&startDate=${queryKey[2]}` : "";
  const endDate = queryKey[3] ? `&endDate=${queryKey[3]}` : "";

  // const startDate = "";
  // const endDate = "";

  var url =
    IP +
    getAPIMap("enterprisePaginationApi") +
    `?pgsize=${10000}&pgindex=${1}${startDate}${endDate}`;
  let response = await axios.get(url, config);

  return response?.data?.count || 0;
};

const getUsersCount = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate =
    queryKey[2] || queryKey[2] === "0" ? `&startDate=${queryKey[2]}` : "";
  const endDate =
    queryKey[3] || queryKey[3] === "0" ? `&endDate=${queryKey[3]}` : "";

  // const startDate = "";
  // const endDate = "";

  var url =
    IP +
    getAPIMap("getuser") +
    `?pgsize=${1}&pgindex=${1}${startDate}${endDate}`;

  let response = await axios.get(url, config);

  return response?.data?.totalUsers;
};
const getVolumetricsPanelForOutbound = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";

  const channel = queryKey[5]
    ? queryKey[5] === "Voice"
      ? `&pr_tp=Voice&i_tp=API`
      : queryKey[5] === "Virtual Receptionist"
      ? `&pr_tp=VR&direction=outbound`
      : ""
    : "";

  var url = `${IP}${getAPIMap(
    queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
      ? "getVoiceVolumetricsPanel"
      : "getVolumetricsPanel"
  )}${fDate && tDate ? `?${fDate}&${tDate}` : ``}${channel}`;
  let response = await axios.get(url, config);
  return response;
};
const getVolumetricsPanelForInbound = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";

  const channel = queryKey[5]
    ? queryKey[5] === "Voice"
      ? `&pr_tp=Voice&i_tp=API`
      : queryKey[5] === "Virtual Receptionist"
      ? `&pr_tp=VR&direction=inbound`
      : ""
    : "";

  var url = `${IP}${getAPIMap(
    queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
      ? "getVoiceVolumetricsPanel"
      : "getVolumetricsPanel"
  )}${fDate && tDate ? `?${fDate}&${tDate}` : ``}${channel}`;
  let response = await axios.get(url, config);
  return response;
};

const getMessageTemplatePie = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate =
    queryKey[2] || queryKey[2] === "0" ? `&fromDate=${queryKey[2]}` : "";
  const endDate =
    queryKey[3] || queryKey[3] === "0" ? `&toDate=${queryKey[3]}` : "";

  var url =
    IP +
    getAPIMap("getMessageTemplatePie") +
    `?filterType=custom${startDate}${endDate}`;

  let response = await axios.get(url, config);

  return response;
};

const getEmailTemplatePie = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate =
    queryKey[2] || queryKey[2] === "0" ? `&fromDate=${queryKey[2]}` : "";
  const endDate =
    queryKey[3] || queryKey[3] === "0" ? `&toDate=${queryKey[3]}` : "";

  var url =
    IP +
    getAPIMap("getEmailTemplatePie") +
    `?filterType=custom${startDate}${endDate}`;

  let response = await axios.get(url, config);

  return response;
};

const getSchedulingTypePie = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate =
    queryKey[2] || queryKey[2] === "0" ? `&stdt=${queryKey[2]}` : "";
  const endDate =
    queryKey[3] || queryKey[3] === "0" ? `&enddt=${queryKey[3]}` : "";
  let channel = "";
  if (queryKey[4] === productNames.sms) {
    channel = `&channels=sms`;
  }
  if (queryKey[4] === productNames.email) {
    channel = `&channels=email`;
  }

  var url =
    IP +
    getAPIMap("getSchedulingTypePie") +
    `?pgsize=${1}&pgindex=${0}${startDate}${endDate}&duration=CUSTOM${channel}`;

  url = url.replace("{channel}", channel);

  let response = await axios.get(url, config);

  return response;
};

const getTPSConsumption = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2]
    ? `?fDate=${customDateFormatStartAndEnd(queryKey[2], "0")}`
    : "";
  const endDate = queryKey[3]
    ? `&tDate=${customDateFormatStartAndEnd(queryKey[3], "1")}`
    : "";

  var url = IP + getAPIMap("getTPSConsumption") + `${startDate}${endDate}`;

  let response = await axios.get(url, config);

  return response;
};

const getEmailCampaigns = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2]
    ? `?stdt=${customDateStartWithoutTz(queryKey[2])}`
    : "";
  const endDate = queryKey[3]
    ? `&enddt=${customDateEndWitoutTz(queryKey[3])}`
    : "";

  let channels = "";
  if (queryKey[4] === "Email") {
    channels = "&channels=email";
  }

  var url =
    IP +
    getAPIMap("getEmailCampaigns") +
    `${startDate}${endDate}${channels}&duration=CUSTOM`;
  let response = await axios.get(url, config);
  return response;
};

const getConcurrentCalls = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2] ? `?fDate=${queryKey[2]}` : "";
  const endDate = queryKey[3] ? `&tDate=${queryKey[3]}` : "";

  var url = IP + getAPIMap("concurrentCalls") + `${startDate}${endDate}`;

  let response = await axios.get(url, config);

  return response;
};

const getWhatsAppCampaigns = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const fDate = queryKey[2]
    ? `stdt=${customDateStartWithoutTz(queryKey[2])}`
    : "";
  const tDate = queryKey[3]
    ? `enddt=${customDateEndWitoutTz(queryKey[3])}`
    : "";

  // const fDate = queryKey[2] ? `stdt=${queryKey[2]}` : "";
  // const tDate = queryKey[3] ? `enddt=${queryKey[3]}` : "";

  var url =
    IP +
    getAPIMap("getWhatsAppCampaigns") +
    `?pgsize=1&pgindex=1${
      fDate && tDate
        ? `&${fDate}&${tDate}&duration=CUSTOM&channels=whatsapp`
        : ""
    }`;

  let response = await axios.get(url, config);
  return response;
};

const getWhatsAppCampaignMessage = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2]
    ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
    : "";
  const endDate = queryKey[3]
    ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
    : "";

  const iType = `&i_tp=0`;

  var url =
    IP + getAPIMap("getWAVolumetricsPanel") + `${startDate}${endDate}${iType}`;
  let response = await axios.get(url, config);
  return response;
};

const getWhatsAppTopCampaigns = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2]
    ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
    : "";
  const endDate = queryKey[3]
    ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
    : "";

  var url =
    IP + getAPIMap("getWhatsAppCampaignMessage") + `${startDate}${endDate}`;

  let response = {
    data: whatsAppTopCampaigns,
  };

  return response;
  // let response = await axios.get(url, config);
  // return response;
};

const getWhatsAppMessageType = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2]
    ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
    : "";
  const endDate = queryKey[3]
    ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
    : "";

  var url =
    IP +
    getAPIMap("getWAVolumetricsPanel") +
    `${startDate}${endDate}&category=dir`;

  //return response;
  let response = await axios.get(url, config);
  return response;
};

const getWhatsAppTemplates = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2]
    ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
    : "";
  const endDate = queryKey[3]
    ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
    : "";

  var url = IP + getAPIMap("getWATemplates") + `${startDate}${endDate}`;

  let response = await axios.get(url, config);
  return response;
};

const getWhatsAppRevenueData = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2]
    ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
    : "";
  const endDate = queryKey[3]
    ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
    : "";

  var url =
    IP +
    getAPIMap("getWhatsAppRevenueData") +
    `${startDate}${endDate}&category=m_ctg`;

  let response = await axios.get(url, config);
  return response;
};

const getWhatsAppTemplateTypes = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2]
    ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
    : "";
  const endDate = queryKey[3]
    ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
    : "";

  const tempType = queryKey[5] ? `&t_tp=${queryKey[5]}` : "";
  var url =
    IP +
    getAPIMap("getWAVolumetricsPanel") +
    `${startDate}${endDate}&category=m_ctg${tempType}`;
  let response = await axios.get(url, config);
  return response;
};

const getWhatsAppScheduleType = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  //   const startDate = queryKey[2]
  //     ? `&fDate=${(queryKey[2])}`
  //     : "";
  //   const endDate = queryKey[3]
  //     ? `&tDate=${(queryKey[3])}`
  //     : "";

  const startDate = queryKey[2]
    ? `stdt=${dayjs(queryKey[2]).format("YYYY-MM-DD")} ${dayjs().format(
        "HH:mm:ss"
      )}`
    : "";
  const endDate = queryKey[3]
    ? `enddt=${dayjs(queryKey[3])
        .subtract(1, "day")
        .format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
    : "";

  var url =
    IP +
    getAPIMap("getWAScheduleType") +
    `?pgsize=${1}&pgindex=${0}&${startDate}&${endDate}&duration=CUSTOM&channels=whatsapp`;

  let response = await axios.get(url, config);
  return response;
};

const getWhatsAppMessageTypeTrend = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2]
    ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
    : "";
  const endDate = queryKey[3]
    ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
    : "";

  var url =
    IP +
    getAPIMap("getWAVolumetricsPanel") +
    `${startDate}${endDate}&category=dir&timeRange=dayOfYear`;

  let response = await axios.get(url, config);
  return response;
};

const getWhatsAppRevenueTrend = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  let timeZone = getTimeZoneInHours();
  const startDate = queryKey[2]
    ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
    : "";
  const endDate = queryKey[3]
    ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
    : "";
  var url =
    IP +
    getAPIMap("getWhatsAppRevenueData") +
    `${startDate}${endDate}&category=m_ctg&timeRange=dayOfYear&timeZone=${timeZone}`;
  let response = await axios.get(url, config);
  return response;
};

const getWhatsAppStatusTrend = async ({ queryKey }) => {
 
  let timeZone = getTimeZoneInHours();
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2]
    ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
    : "";
  const endDate = queryKey[3]
    ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
    : "";
// wabaParam is omitted entirely when no WABA is selected (e.g. filter cleared via isClearable).
const wabaParam =
  queryKey[5] !== undefined && queryKey[5] !== null && queryKey[5] !== ""
    ? `&wa_ba=${encodeURIComponent(queryKey[5])}`
    : "";
// m_ctg=12 is only added when called from FreeTierConsumptionTrend, flagged via queryKey[6].
const mCtgParam = queryKey[6] === "freeTierTrend" ? `&m_ctg=12` : "";


  var url =
    IP +
    getAPIMap("getWAVolumetricsPanel") +
    `${startDate}${endDate}&category=free&timeRange=dayOfYear&timeZone=${timeZone}${wabaParam}${mCtgParam}`;

  let response = await axios.get(url, config);
  return response;
};

const getWhatsAppTotalRevenue = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2]
    ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
    : "";
  const endDate = queryKey[3]
    ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
    : "";

  var url = IP + getAPIMap("getWhatsAppRevenueData") + `${startDate}${endDate}`;
  let response = await axios.get(url, config);
  return response;
};

// const getEmailCampaignMessage = async ({ queryKey }) => {
//   const config = {
//     headers: {
//       Authorization: `Bearer ${queryKey[1]}`,
//     },
//   };

//   const startDate = queryKey[2] ? `?fDate=${queryKey[2]}` : "";
//   const endDate = queryKey[3] ? `&tDate=${queryKey[3]}` : "";
//   // const startDate1 = queryKey[2] ? `?fDate=${queryKey[2]}` : "";

//   var url =
//     IP + getAPIMap("getEMAILVolumetricsPanel") + `${startDate}${endDate}`;
//   let response = await axios.get(url, config);
//   return response;
// };
const getEmailScheduleType = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2]
    ? `&stdt=${customDateStartWithoutTz(queryKey[2])}`
    : "";
  const endDate = queryKey[3]
    ? `&tDate=${customDateEndWitoutTz(queryKey[3])}`
    : "";

  let channels = "";
  if (queryKey[4] === productNames.email) {
    channels = "&channels=email";
  }

  var url =
    IP +
    getAPIMap("getEmailScheduleType") +
    `?duration=CUSTOM${startDate}${endDate}${channels}`;

  let response = await axios.get(url, config);
  return response;
};

const getEmailRevenueTrend = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2] ? `?fDate=${queryKey[2]}` : "";
  const endDate = queryKey[3] ? `&tDate=${queryKey[3]}` : "";

  var url =
    IP +
    getAPIMap("getEmailRevenueData") +
    `${startDate}${endDate}&category=dir,m_ctg&timeRange=dayofyear`;
  let response = await axios.get(url, config);
  return response;
};
const getEmailStatusTrend = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2] ? `?fDate=${queryKey[2]}` : "";
  const endDate = queryKey[3] ? `&tDate=${queryKey[3]}` : "";

  var url =
    IP +
    getAPIMap("getEMAILVolumetricsPanel") +
    `${startDate}${endDate}&category=m_ctg&timeRange=dayofyear`;

  let response = await axios.get(url, config);
  return response;
};

const getTotalCampaignsCountForVoice = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const fDate = queryKey[2] ? `&stdt=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `&enddt=${queryKey[3]}` : "";

  var url =
    IP +
    getAPIMap("totalCampaignsCountForVoice") +
    `?pgsize=1&pgindex=1&srctype=0` +
    `${fDate && tDate ? `${fDate}${tDate}&duration=CUSTOM` : ""}`;

  let response = await axios.get(url, config);

  return response;
};
const getTotalCampaignsCountForVoiceForApiHits = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const fDate = queryKey[2] ? `&stdt=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `&enddt=${queryKey[3]}` : "";

  var url =
    IP +
    getAPIMap("totalCampaignsCountForVoice") +
    `?pgsize=1&pgindex=1&srctype=1` +
    `${fDate && tDate ? `${fDate}${tDate}&duration=CUSTOM` : ""}`;

  let response = await axios.get(url, config);

  return response;
};
const getRevenueDataForVoice = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2] ? `&fDate=${queryKey[2]}` : "";
  const endDate = queryKey[3] ? `&tDate=${queryKey[3]}` : "";

  var url =
    IP +
    getAPIMap("revenueDataForVoice") +
    `?pgsize=1&pgindex=1&type=pie` +
    `${startDate}${endDate}`;

  let response = await axios.get(url, config);

  return response;
};
const getRevenueTrendDataForVoice = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const startDate = queryKey[2] ? `&fDate=${queryKey[2]}` : "";
  const endDate = queryKey[3] ? `&tDate=${queryKey[3]}` : "";
  const category =
    queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";

  var url =
    IP +
    getAPIMap("revenueTrendDataForVoice") +
    `?pgsize=1&pgindex=1&type=trend` +
    `${startDate}${endDate}${category}`;

  let response = await axios.get(url, config);

  return response;
};

const getWhatsAppInboundSummary = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };
  const fDate = queryKey[2]
    ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
    : "";
  const tDate = queryKey[3]
    ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
    : "";

  let direction = `&dir=1`;
  // var url = `${IP}${getAPIMap("getWAVolumetricsPanel")}
  // ${fDate && tDate ? `?${fDate}&${tDate}` : ``}${direction}`;
  // var url = IP + getAPIMap("getWAVolumetricsPanel") + `${fDate}${tDate}${direction}`;
  var url =
    IP +
    getAPIMap("getWAVolumetricsPanel") +
    `?${fDate && tDate ? `${fDate}&${tDate}&dir=1` : ""}`;

  let response = await axios.get(url, config);
  return response;
};

const getTemplateDistribution = async ({ queryKey }) => {
  const token = queryKey[1],
    fromDate = queryKey[2],
    toDate = queryKey[3],
    status = queryKey[4],
    category = queryKey[5];
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const params = [
    fromDate && `fDate=${customDateStartUTCTimeZoneZ(fromDate)}`,
    toDate && `tDate=${customDateEndUTCTimeZoneZ(toDate)}`,
    category && `category=${category}`,
    status && `status=${status}`,
  ]
    .filter(Boolean)
    .join("&");

  const url = `${IP}${getAPIMap("getWaTemplatesList")}${
    params ? `?${params}` : ""
  }`;

  const response = await axios.get(url, config);
  return response;
};

const getWAABusinessNumCounter = async ({ queryKey }) => {
  const token = queryKey[1],
    fromDate = queryKey[2],
    toDate = queryKey[3]; //status = queryKey[4]
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const params = [
    fromDate && `fDate=${customDateStartUTCTimeZoneZ(fromDate)}`,
    toDate && `tDate=${customDateEndUTCTimeZoneZ(toDate)}`,
  ]
    .filter(Boolean)
    .join("&");

  const url = `${IP}${getAPIMap("getClients")}${params ? `?${params}` : ""}`;

  const response = await axios.get(url, config);
  return response;
};

const getWAATemplateAnalyticsApi = async ({ queryKey }) => {
  const token = queryKey[1],
    fromDate = queryKey[2],
    toDate = queryKey[3],
    tempId = queryKey[4]; //status = queryKey[4]
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const params = [
    fromDate && `start=${customDateStartUTCTimeZoneZ(fromDate)}`,
    toDate && `end=${customDateEndUTCTimeZoneZ(toDate)}`,
  ]
    .filter(Boolean)
    .join("&");

  const url = `${IP}${getAPIMap("getWAATemplateAnalyticsData")}${tempId}${
    params ? `?${params}` : ""
  }`;
  const response = await axios.get(url, config);
  return response;
};

const getWhatsappTemplateList = async (token, prevOptions, pgIndex, search) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const url = `${IP}${getAPIMap("getWaTemplatesList")}?pgsize=${
    tableDetails.pageSize
  }&pgindex=${pgIndex}&status=${"approved"}${
    search !== "" ? `&search=${search}` : ""
  }`;
  // &search=${search}
  const response = await axios.get(url, config);
  const data = response?.data?.data || [];

  const total = response?.data?.toltalCount;
  let templatesOptions = data?.map((e) => ({
    value: e.template_id,
    label: e.template_name,
  }));

  // if (pgIndex === 1) {
  //   templatesOptions.unshift({ label: "All", value: "all" });
  // }

  return {
    options: templatesOptions,
    hasMore: Math.ceil(total / tableDetails.pageSize) > pgIndex, //data.length === 10,
    additional: {
      page: pgIndex + 1,
    },
  };
};

// queryKey: [key, token, fDate, tDate, profile]
const getAuthConfigMetricsCount = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
  const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
  const profile =
    queryKey[4] && queryKey[4] !== "ALL" && queryKey[4] !== "All"
      ? `profile=${queryKey[4]}`
      : "";

  const params = [fDate, tDate, profile].filter(Boolean).join("&");
  const url = `${IP}${getAPIMap("getAuthConfigMetricsCount")}${
    params ? `?${params}` : ""
  }`;

  const response = await axios.get(url, config);
  return response;
};

export {
  getAuthConfigMetricsCount,
  getPerformancePie,
  getInterfacePie,
  getSummaryPanel,
  getAllEmailVolPanel,
  getVolumetricsPanel,
  getStatusTrendGraph,
  getNumbersPanel,
  getNumberPanel,
  getSenderPie,
  getCampaignRevenue,
  getAllEmailCampaignRevenue,
  getTopPackages,
  getTopEnterprises,
  getNumberInventoryStatusPanel,
  getNumberConfigurationPanel,
  getCampaignsPanel,
  getCampaignCallsPanel,
  getSummaryRevenue,
  getRevenueTrendEmail,
  getEmailMetrics,
  getAccountCount,
  getUsersCount,
  getVolumetricsPanelForOutbound,
  getVolumetricsPanelForInbound,
  getMessageTemplatePie,
  getEmailTemplatePie,
  getTopEnterprisesForEmail,
  getTopPackagesForEmail,
  getEmailScheduleType,
  getSchedulingTypePie,
  getTPSConsumption,
  getEmailCampaigns,
  getSmsCampaignPanel,
  getEmailRevenueTrend,
  getEmailStatusTrend,
  getWhatsAppCampaigns,
  getWhatsAppCampaignMessage,
  getWhatsAppTopCampaigns,
  getWhatsAppMessageType,
  getWhatsAppTemplates,
  getWhatsAppRevenueData,
  getWhatsAppTemplateTypes,
  getWhatsAppScheduleType,
  getSummaryRevenueForVoice,
  getCampaignRevenueForVoice,
  getTopEnterprisesforVoice,
  getTopPackagesForVoice,
  getConcurrentCalls,
  getWhatsAppMessageTypeTrend,
  getWhatsAppRevenueTrend,
  getWhatsAppStatusTrend,
  getWhatsAppTotalRevenue,
  getTotalCampaignsCountForVoice,
  getTotalCampaignsCountForVoiceForApiHits,
  getRevenueDataForVoice,
  getRevenueTrendDataForVoice,
  getApiCallsPanel,
  getVoiceVolumetricsPanel,
  getWASummaryPanel,
  getWhatsAppInboundSummary,
  getTemplateDistribution,
  getWAABusinessNumCounter,
  getWhatsappTemplateList,
  getWAATemplateAnalyticsApi,
};
